import React from "react"
import Typography from "aldoo-ra/Typography"
import CMSRender from "aldoo-ra/CMS/cms-render"
import parse from "html-react-parser"
import Localization from "aldoo-ra/Localization"
import BackgroundOverlay from '@components/Site/BackgroundOverlay.jsx'

export default function () {
  const { t } = Localization();

  return (
    <div className="relative w-full bg-canvas transition-colors pt-16 lg:pt-[180px] pb-[360px]">
      <BackgroundOverlay />

      {/* Privacy Policy Title + Body */}
      <CMSRender
        contentType="ServiceText"
        match={{ "content.id": "privacy" }}
        renderItem={(data) => {
          return (
            <div>
              <div className="relative flex flex-col items-center w-full max-w-[700px] md:max-w-[900px] xl:max-w-w1_xl px-4 md:px-10 xl:px-20 mx-auto z-50">
                <Typography 
                  component="h1"
                  variant="h2" 
                  className="text-text mb-20"
                >
                  {data.title}
                </Typography>

                <div className="service_page w-full text-text">
                  {data.text && typeof data.text === 'string' ? parse(data.text) : data.text}
                </div>
              </div>
            </div>
          );
        }}
      />
    </div>
  )
}